import * as classnames from 'classnames';
import * as React from 'react';

import './Overlay.scss';

interface OverlayProps {
  className?: string;
  modifier?: 'clickable' | undefined;
  onClick?: MSExecAtPriorityFunctionCallback;
}

export class Overlay extends React.Component<OverlayProps, {}> {
  render() {
    const { children, className, modifier, ...rest } = this.props;
    const classNameModifier = modifier && 'overlay--' + modifier;
    return (
      <div className={classnames('overlay', classNameModifier, className)} {...rest}>
        {children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Overlay/Overlay.tsx